// jshint esversion:6
import api from './api'

export default class Resource {
  constructor (resource) {
    this.resource = resource
  }
  getAll (queryString = null) {
    return api.get(`${this.resource}/${queryString}`)
  }
  get (id) {
    return api.get(`${this.resource}/${id}`)
  }
  update (id, payload) {
    return api.patch(`${this.resource}/${id}/`, payload)
  }
  post (payload) {
    return api.post(`${this.resource}/`, payload)
  }
  upload (id, payload) {
    const headers = { 'Content-Type': 'multipart/form-data' }
    return api.put(`${this.resource}/${id}/`, payload, { headers: headers })
  }
}
